<template>
    <v-row class="pa-2 fill-height" justify="space-between" align="stretch">
        <v-col cols="12" class="pb-0">
            <v-row justify="space-between" align="stretch" no-gutters class="px-2">
                 <v-col cols="12"> <h3 class="mb-2">Budget Overview</h3> </v-col>
            </v-row>
            <v-row justify="space-between" align="stretch" no-gutters>
                <v-col cols="3">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">£ {{budgetData.spent}}</v-list-item-title>
                            <v-list-item-subtitle>Amount Spent</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="6" >
                    Available<strong> £ {{parseFloat(availableAmount).toFixed(2)}}</strong>
                    <v-progress-linear
                        background-color="error"
                        color="success"
                        :value="BarValue"
                        height= "12"
                        bottom 
                        rounded
                    >
                    </v-progress-linear>
                </v-col>
                <v-col cols="3">
                    <v-list-item two-line >
                        <v-list-item-content >
                            <v-list-item-title class="font-weight-bold">£ {{budgetData.max}}</v-list-item-title>
                            <v-list-item-subtitle>Limit</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row> 
            <v-row justify="space-between" align="stretch" no-gutters>
                <v-col cols="4">
                    <v-list-item two-line>
                        <v-list-item-content >
                            <v-list-item-title class="font-weight-bold">{{budgetDates.starts}}</v-list-item-title>
                            <v-list-item-subtitle>Starts</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="4">
                    <v-list-item two-line>
                        <v-list-item-content >
                            <v-list-item-title class="font-weight-bold">{{budgetDates.expires}}</v-list-item-title>
                            <v-list-item-subtitle>Expires</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col cols="4" two-line>
                    <v-list-item>
                        <v-list-item-content >
                            <v-list-item-title class="font-weight-bold"> 
                                <v-icon color="success" v-if="budgetData.budget_rollover == '1'">check_circle_outline</v-icon>
                                <v-icon color="error" v-else>cancel</v-icon>
                            </v-list-item-title>
                            <v-list-item-subtitle>Roll Over</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>  
            </v-row>     
        </v-col>
    </v-row>
    
</template>
<script>
import axios from "axios";
import moment from "moment";
import {mapGetters} from "vuex"
export default {
    name :'BudgetOverview',
    data :()=>{
        return{
            budgetData:null,
        }
    },
    activated() {
        this.getBudget();
    },
    computed:{
        //...mapGetters(['retrieveAccountCustomerCredit']),
        BarValue(){
            if (this.budgetData) {
                let spentPercent = (this.budgetData.spent / this.budgetData.max) * 100
                return 100- spentPercent
            } else {
                return 0
            }
        },
        availableAmount(){
            if ( this.budgetData) {
                return this.budgetData.max - this.budgetData.spent
            } else {
                return 0
            }
        },
        // isAccountCustomer() {
        //     if (
        //         !this.$store.getters.retrieveIsCncCustomer &&
        //         !this.$store.getters.retrieveIsCashCustomer
        //     ) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // },
        budgetDates() {
            if (this.budgetData) {
                let date = moment(this.budgetData.startDate.split(" ")[0], 'YYYY-MM-DD')
                let expiryStr = this.budgetData.length.split(" ")
                let expiryNum = expiryStr[0].replace("+","")
                let expiryDuration = expiryStr[1] 
                return {
                    starts : date.format('MMM Do YY') ,
                    expires : date.add(parseInt(expiryNum),expiryDuration).format('MMM Do YY') 
                }
            }
            return {
                starts :0,
                expires : 0
            }
        }
    }, 
    methods:{
        async getBudget() {
            let stringPayload = JSON.stringify({
                userId: this.$store.getters.retrieveUser.userNum,
                sessionKey: this.$store.getters.retrieveUser.sessionKey,
            });
            const params = new URLSearchParams();
            params.append("params", stringPayload);
            await axios.post("get-customer-budget", params).then((response) => {
                if (response.data.success) {
                    this.budgetData = response.data.budget
                } else {
                    this.$emit('budget-hide');
                }
            })
        }
    }
}
</script>